import React, { useEffect } from "react"
import { useParams } from "react-router-dom"
import ThemeLayout from "layouts/ThemeLayout"
import useQuery from "services/useQuery"
import { getTheme } from "services/theme"
import useShare from "utils/wechat/useShare"
import useConfig from "utils/wechat/useConfig"
// import config from "config/default"
import CourseItem from './Item'
import { getFileUrl } from "utils/utils"

/**
 * 课程主题页
 */
export default function ThemeRoute() {
    const { theme } = useParams()
    const { data } = useQuery(getTheme, theme)
    const header = data ? data.header_url : ''
    const footer = data ? data.footer_url : ''

    const { wechatReady } = useConfig()
    useShare(wechatReady, data && {
        imgUrl: getFileUrl(theme, data.share_url),
        title: data.title,
        desc: data.desc || data.title,
    })

    useEffect(
        () => {
            if (data) {
                document.title = data.title
            }
        },
        [data]
    )

    return (
        <ThemeLayout
            theme={theme}
            header={header}
            footer={footer}
        >
            {
                data && data.courses.map(item => (
                    <CourseItem
                        item={item}
                        theme={theme}
                        key={item.id}
                    />
                ))
            }
        </ThemeLayout>
    )
}